import { render, staticRenderFns } from "./sectionDeleteImageDialog.vue?vue&type=template&id=6ece97d6&scoped=true&"
import script from "./sectionDeleteImageDialog.vue?vue&type=script&lang=js&"
export * from "./sectionDeleteImageDialog.vue?vue&type=script&lang=js&"
import style0 from "./sectionDeleteImageDialog.vue?vue&type=style&index=0&id=6ece97d6&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ece97d6",
  null
  
)

export default component.exports